export default {
  createUnitClass: 'create unit class',
  editUnitClass: 'edit unit class',
  viewUnitClass: 'view unit class',
  createUnit: 'create unit',
  editUnit: 'edit unit',
  viewUnit: 'view unit',
  unitClassCode: 'unit class code',
  unitClassName: 'unit class name',
  unitCode: 'unit code',
  unitName: 'unit name',
  unitSymbol: 'unit symbol',
  pleaseSelectUnitClass: 'please select the class first',
  whetherDeleteUnit: 'are you sure to delete this unit',
  whetherDeleteUnitClass: 'are you sure to delete this unit class',
  unitCodeCanNotBeNull: 'unit code can not be empty',
  unitNameCanNotBeNull: 'unit name can not be empty',
  unitSymbolCanNotBeNull: 'unit symbol can not be empty',
  unitClassCodeCanNotBeNull: 'unit class code can not be empty',
  unitClassNameCanNotBeNull: 'unit class name can not be empty',
}
